import { render, staticRenderFns } from "./PortSlotPill.vue?vue&type=template&id=8278617c&scoped=true&"
import script from "./PortSlotPill.vue?vue&type=script&lang=js&"
export * from "./PortSlotPill.vue?vue&type=script&lang=js&"
import style0 from "./PortSlotPill.vue?vue&type=style&index=0&id=8278617c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8278617c",
  null
  
)

export default component.exports